<template>
  <section>
    <b-modal width="680px" :active.sync="isCardModalActive" :can-cancel="false">
      <div class="card" style="border-radius: 5px;" v-if="isCardModalActive">
        <header class="card-header">
          <div class="card-header-title edit-title-wrapper">
            <span class="edit-title">面接予定日作成</span>
          </div>
        </header>
        <div class="card-content scroll-box">
          <!-- イベント作成/候補日時設定 -->
          <template v-if="step===0">
            <div class="message disp-scroll">
              <b-tabs style="background: white;">
                <b-tab-item label="基本設定" class="tab-box disp-scroll">
                  <div class="tab-box-form">
                    <div class="tab-box-left">
                      <p style="text-align: left;">
                        <b>タイトル</b>
                      </p>
                    </div>
                    <div class="tab-box-right">
                      <b-input style="width: 100%;" placeholder="タイトルを入力" v-model="info.title" max-length="100"></b-input>
                    </div>
                  </div>
                  <div class="dot-line"></div>
                  <div class="tab-box-form">
                    <div class="tab-box-left">
                      <p style="text-align: left;">
                        <b>開始日時</b>
                      </p>
                    </div>
                    <div class="tab-box-right">
                      <b-datetimepicker
                          rounded
                          v-model="start_date"
                          placeholder="開始日時"
                          size = "is-small"
                          icon="calendar-today">
                      </b-datetimepicker>
                    </div>
                  </div>
                  <div class="tab-box-form">
                    <div class="tab-box-left">
                      <p><b>予定時間</b></p>
                    </div>
                    <div class="tab-box-right">
                      <p style="display: flex; align-items: center;">
                        <b-numberinput style="width: 100px;" size="is-small" :editable="false" step="1" min="0" max="23" v-model="info.mtg_time_hour" controls-position="compact"></b-numberinput>
                        <span style="margin-left: 4px;">時間</span>
                      </p>
                      <p style="display: flex; align-items: center; margin-left: 16px;">
                        <b-numberinput style="width: 100px;" size="is-small" :editable="false" step="15" min="0" max="45" v-model="info.mtg_time_minute" controls-position="compact"></b-numberinput>
                        <span style="margin-left: 4px;">分</span>
                      </p>
                    </div>
                  </div>
                  <template v-if="calendarUserExists">
                    <div class="dot-line"></div>
                    <div class="tab-box-form">
                      <div class="tab-box-left" style="flex-wrap: wrap;">
                        <p><b>メモ</b></p>
                        <br>
                        <span style="text-align: left; color: #666; font-size: 12px;">日程調整をした日の予定に入れるメモ欄です。</span>
                      </div>
                      <div class="tab-box-right">
                        <textarea class="input textarea disp-scroll" v-model="info.memo" maxlength="200"></textarea>
                      </div>
                    </div>
                    <div class="dot-line"></div>
                    <div class="tab-box-form">
                      <div class="tab-box-left" style="flex-wrap: wrap;">
                        <p style="text-align: left;">
                          <b>必須参加者</b>
                          <br>
                          <span style="color: #666; font-size: 12px;">最低1人以上お選びください</span>
                        </p>
                      </div>
                      <div class="tab-box-right" style="flex-wrap: wrap;">
                        <SelectMemberTable
                          :isCalendar="true"
                          :users = users
                          :selfUser="user"
                          :parameterHash="info.user_hash"
                          :calendarSettings="calendarSettings"
                          :default2="true"
                          :isSync="true"
                          :usersStatusAPI="usersStatusAPI"
                          @changeShowEventSelectMember="changeUserHash"
                          @changeShowEventSelfSelectMember="changeUserHashSelf"
                          @createCalendarSettingsSelectMember="changeUserHashFromNo"
                          style="height: 250px;"/>
                      </div>
                    </div>
                    <div class="dot-line"></div>
                    <div class="tab-box-form">
                      <div class="tab-box-left" style="flex-wrap: wrap;">
                        <p style="text-align: left;">
                          <b>任意参加者</b>
                          <br>
                          <span style="color: #666; font-size: 12px;">選択した中から1人が選ばれます</span>
                        </p>
                      </div>
                      <div class="tab-box-right" style="flex-wrap: wrap;">
                        <SelectMemberTable
                          :isCalendar="true"
                          :users = users
                          :selfUser="user"
                          :parameterHash="info.user_hash_sub"
                          :calendarSettings="calendarSettings"
                          :default2="false"
                          :isSync="true"
                          :usersStatusAPI="usersStatusAPI"
                          @changeShowEventSelectMember="changeUserHashSub"
                          @changeShowEventSelfSelectMember="changeUserHashSubSelf"
                          @createCalendarSettingsSelectMember="changeUserHashSubFromNo"
                          style="height: 250px;"/>
                      </div>
                    </div>
                    <div class="dot-line"></div>
                    <div class="tab-box-form">
                      <div class="tab-box-left">
                        <p><b>共有者</b></p>
                      </div>
                      <div class="tab-box-right" style="flex-wrap: wrap;">
                        <SelectMemberTable
                          :isCalendar="true"
                          :users = users
                          :selfUser="user"
                          :parameterHash="info.user_hash_share"
                          :calendarSettings="calendarSettings"
                          :default2="false"
                          :isSync="true"
                          :usersStatusAPI="usersStatusAPI"
                          @changeShowEventSelectMember="changeUserHashShare"
                          @changeShowEventSelfSelectMember="changeUserHashShareSelf"
                          @createCalendarSettingsSelectMember="changeUserHashShareFromNo"
                          style="height: 250px;"/>
                      </div>
                    </div>
                  </template>
                </b-tab-item>
                <b-tab-item label="リマインダー設定" class="tab-box disp-scroll">
                  <div class="tab-box-form">
                    <div class="tab-box-left">
                      <p style="text-align: left;">
                        <b>リマインダー通知</b>
                        <br>
                        <span style="color: #666; font-size: 12px;">ONにすると設定したメールが届きます</span>
                      </p>
                    </div>
                    <div class="tab-box-right">
                      <b-switch style="width: 100%;" v-model="reminder_flg">切替</b-switch>
                    </div>
                  </div>
                  <div class="dot-line"></div>
                  <div class="tab-box-form">
                    <div class="tab-box-left">
                      <p style="text-align: left;">
                        <b>リマインダー通知日</b>
                        <br>
                        <span style="color: #666; font-size: 12px;">日程調整をした日の何日前に送るか設定します</span>
                      </p>
                    </div>
                    <div class="tab-box-right">
                      <p style="display: flex; align-items: center;">
                        <b-numberinput v-model="info.reminder_day" :editable="false" min="1" max="10" style="width: 100px;" size="is-small" controls-position="compact" :disabled="!info.reminder_flg"></b-numberinput>
                        <span style="margin-left: 4px;">日前</span>
                      </p>
                    </div>
                  </div>
                  <div class="dot-line"></div>
                  <div class="tab-box-form">
                    <div class="tab-box-left">
                      <p style="text-align: left;">
                        <b>直前リマインダー通知</b>
                        <br>
                        <span style="color: #666; font-size: 12px;">ONにすると登録された予定時間の直前に再度メールが届きます<br/>※30分〜120分前の間で設定可能です</span>
                      </p>
                    </div>
                    <div class="tab-box-right">
                      <b-switch style="width: 40%;" v-model="reminder_before_flg" :disabled="!info.reminder_flg">切替</b-switch>
                      <p style="display: flex; align-items: center;">
                        <b-numberinput style="width: 100px;" size="is-small" :editable="false" step="10" min="30" max="120" v-model="info.reminder_before_minute" controls-position="compact" :disabled="!info.reminder_flg||!info.reminder_before_flg"></b-numberinput>
                        <span style="margin-left: 4px;">分前</span>
                      </p>
                    </div>
                  </div>
                  <template v-if="calendarUserExists">
                    <div class="dot-line"></div>
                    <div class="tab-box-form">
                      <div class="tab-box-left">
                        <p style="text-align: left;">
                          <b>メンバーにも送付</b>
                          <br>
                          <span style="color: #666; font-size: 12px;">ONにすると基本設定で選択したメンバーおよびユーザーにもメールが届きます</span>
                        </p>
                      </div>
                      <div class="tab-box-right">
                        <b-switch style="width: 100%;" v-model="info.reminder_member_flg" :disabled="!info.reminder_flg">切替</b-switch>
                      </div>
                    </div>
                  </template>
                  <div class="dot-line"></div>
                  <div class="tab-box-form">
                    <div class="tab-box-left">
                      <p style="text-align: left;">
                        <b>メール内容</b>
                        <br>
                        <span style="color: #666; font-size: 12px;">リマインダーメールの内容を設定できます</span>
                        <br>
                        <span style="color: #666; font-size: 12px;">メールはHRモンスター（noreply@hr-monster.io）からお送りいたします。</span>
                      </p>
                    </div>
                    <div class="tab-box-right" style="flex-wrap: wrap;">
                      <p style="width: 100%; text-align: left;font-weight: bold;">件名</p>
                      <b-input style="width: 100%;" placeholder="例：件名を入力" v-model="info.reminder_title" :disabled="!info.reminder_flg"></b-input>
                      <hr>
                      <p style="width: 100%; text-align: left;font-weight: bold;">TO（カンマ区切りで追加できます。）</p>
                      <b-input style="width: 100%;" placeholder="例：TOを入力" v-model="info.reminder_to" :disabled="!info.reminder_flg"></b-input>
                      <hr>
                      <p style="width: 100%; text-align: left;font-weight: bold;">CC（カンマ区切りで追加できます。）</p>
                      <b-input style="width: 100%;" placeholder="例：CCを入力" v-model="info.reminder_cc" :disabled="!info.reminder_flg"></b-input>
                      <hr>
                      <p style="width: 100%; text-align: left; font-weight: bold;">メールの内容を入力してください。</p>
                      <div style="width: 100%; height: auto;">
                        <quill-editor v-model="info.reminder_content" ref="quillEditor" :options="optionsRemainder" :disabled="!info.reminder_flg"></quill-editor>
                      </div>
                    </div>
                  </div>
                </b-tab-item>
              </b-tabs>
            </div>
            <b-field style="width: 100%">
              <div style="width: 48%; align: left">
                <button class="button is-primary is-fullwidth" @click="closeEditPage();">
                  キャンセル
                </button>
              </div>
              <div style="width: 5%;">
              </div>
              <div style="width: 48%; align: right" v-if="calendarUserExists">
                <button class="button is-primary is-fullwidth" @click="clickRecommendEvent()" :disabled="!isActive">
                  候補日時作成
                </button>
              </div>
              <div style="width: 48%; align: right" v-else>
                <button class="button is-primary is-fullwidth" @click="confirmSchedule(seeker)">
                  面接予定日確定
                </button>
              </div>
            </b-field>
          </template>
          <template v-if="step===1 && calendarUserExists">
            <div class="message disp-scroll">
              <template v-if="!isRecommendSchedule">
                <div style="height: auto; width: 100%; display: flex; justify-content: center; align-items: center;">
                  <span class="mdi mdi-loading mdi-spin"></span>候補日時を読み込んでいます
                </div>
              </template>
              <template v-else-if="isErrorRecommendSchedule&&isRecommendSchedule">
                <div style="height: 100%; width: 100%; display: flex; justify-content: center; align-items: center;">
                  候補日時をお取りすることができませんでした。<br>
                  本画面を閉じていただき、もう一度設定をご確認の上、候補日時作成をお願いいたします。
                </div>
              </template>
              <template v-else>
                <div style="height: auto; width: 100%; display: flex; justify-content: center; align-items: center; flex-direction: column;">
                  <p class="message-title" style="font-weight: 600; font-size: 18px; margin: 16px;">日付をお選びください。</p>
                  <template>
                    <button
                      v-for="(m, index) in recommendDateButton"
                      :key="index"
                      v-if="m"
                      class="button"
                      style="margin: 8px;"
                      :disabled="isdisabled"
                      @click="makeEvent(m, index, seeker)"
                    >{{ m }}</button>
                  </template>
                </div>
              </template>
            </div>
            <hr>
            <b-field style="width: 100%">
              <div style="width: 48%; align: left">
                <button class="button is-primary is-fullwidth" @click="prevDay()" :disabled="!isRecommendSchedule||isErrorRecommendSchedule||preserveSuggestedSchedulesList.length===0||isdisabled">
                  前の候補日時へ
                </button>
              </div>
              <div style="width: 5%;">
              </div>
              <div style="width: 48%; align: right">
                <button class="button is-primary is-fullwidth" @click="nextDay()" :disabled="!isRecommendSchedule||isErrorRecommendSchedule||preserveSuggestedSchedulesList===0||isdisabled">
                  次の候補日時へ
                </button>
              </div>
            </b-field>
            <b-field style="width: 100%">
              <div style="width: 100%; align: center">
                <button class="button is-primary is-fullwidth" @click="goback()" :disabled="!isRecommendSchedule||isErrorRecommendSchedule||preserveSuggestedSchedulesList===0||isdisabled">
                  戻る
                </button>
              </div>
            </b-field>
          </template>
          <div class="card-body" v-if="step===2">
            <div class="disp-scroll" style="width: 80%; margin: auto">
              <MailActionContent
                :chatbots="chatbots"
                :recordingInterviews="recordingInterviews"
                :users="users"
                :bulk="false"
                :options="options"
                :emailTemplates="emailTemplates"
                :copyLink="copyLink"
                :sendEmailToSeeker="sendEmailToSeeker"
                :sendLoadding="sendLoadding"
                :sendEmailTemplate="sendEmailTemplate"
                :changeEmailTemplate="changeEmailTemplate"
                :tempSaveEmail="tempSaveEmail"
                :helpMessage="helpMessage"
                :openEmailMenu="openEmailMenu"
                :isSaveButton="true"
                :isLinkMenu="true"
                :isReplaceExplanation="true"
                :date="{'start_date_and_time': startDateAndTime, 'end_date_and_time': endDateAndTime}"
              />
            </div>
          </div>
          <hr>
          <div class="footer-box" v-if="step===2">
            <button class="button" @click="closeEditPage()">送付せず終了する</button>
            <div style="width: 47%;"></div>
          </div>
          <div class="footer-box" v-if="step===1&&isErrorRecommendSchedule&&isRecommendSchedule">
            <button class="button" @click="closeEditPage()">閉じる</button>
            <div style="width: 47%;"></div>
          </div>
        </div>
      </div>
    </b-modal>
  </section>
</template>

<script>
import { mapState } from 'vuex'
import moment from 'moment'
import createUUID from '@/functions/createUUID'
import CalendarAPIStatus from '@/views/DashBoard/Calendar/CalendarAPIStatus'
import _ from 'lodash'
import Tooltip from '@/components/atoms/tooltips/Tooltip'
import SelectMemberTable from '@/components/molecules/tables/SelectMemberTable'
import MailActionContent from "@/components/organisms/emails/MailActionContent";
export default {
  name: 'ModalCreateInterviewDate',
  components: {
    CalendarAPIStatus,
    Tooltip,
    SelectMemberTable,
    MailActionContent
  },
  props: {
    calendarSettings: {
      type: Array,
      require: true
    },
    archiveSwitch: {
      type: Boolean,
      required: true,
    },
    blacklistSwitch: {
      type: Boolean,
      required: true,
    },
    orSwitch: {
      type: Boolean,
      required: true,
    },
    filtered: {
      type: Array,
      required: true,
    },
    seekersPages: {
      type: Number,
      required: true,
    },
    perPage: {
      type: Number,
      required: true,
    },
    currentManage: {
      type: Number
    },
    chatbots: {
      type: Array,
      required: true
    },
    recordingInterviews: {
      type: Array,
      required: true
    },
    options: {
      type: Object,
      required: true
    },
    emailTemplates: {
      type: Array,
      required: true
    },
    sendEmailToSeeker: {
      type: Function,
      required: true
    },
    sendLoadding: {
      type: Boolean,
      required: true
    },
    sendEmailTemplate: {
      type: Object,
      required: false
    },
    changeEmailTemplate: {
      type: Function,
      required: true
    },
    tempSaveEmail: {
      type: Function,
      required: true
    },
    helpMessage: {
      type: Function,
      required: true
    },
    copyLink: {
      type: Function,
      required: true
    },
    openEmailMenu: {
      type: Function,
      required: true
    },
    usersStatusAPI: {
      type: Array,
      required: true  
    },
    info: {
      type: Object,
      required: true
    },
    seeker: {
      type: Object,
      required: true
    },
    isCardModalActive: {
      type: Boolean,
      required: true
    },
    isDuplicateSeekerFlag: {
      type: Boolean,
      required: false,
      default: false,
    },
    isGetRoboTalk: {
      type: Boolean,
      required: false,
      default: false,
    }
  },
  async mounted() {
    this.calendarUserExistsCheck()
  },
  computed: {
    ...mapState('auth', ['user', 'users', 'departments', 'positions']),
    ...mapState('calendar', ['recommendDate', 'isErrorRecommendSchedule', 'preserveSuggestedSchedulesList', 'isRecommendSchedule', 'eventFileGroup', 'eventGroup']),
    recommendDateButton () {
      let retRecommendDate = []
      for (const i in this.recommendDate) {
        retRecommendDate.push(
          new Date(this.recommendDate[i].start).getFullYear() + '/' +
          (new Date(this.recommendDate[i].start).getMonth() + 1) + '/' + new Date(this.recommendDate[i].start).getDate() + ' (' +  this.weekday[new Date(this.recommendDate[i].start).getDay()] + ') ' +
          new Date(this.recommendDate[i].start).getHours() +     ':' + ('00' + new Date(this.recommendDate[i].start).getMinutes()).slice(-2) + ' ~ ' +
          new Date(this.recommendDate[i].end).getHours()   +     ':' + ('00' + new Date(this.recommendDate[i].end).getMinutes()).slice(-2)
        )
      }
      return retRecommendDate
    },
  },
  data () {
    return {
      timeList: [
        0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23
      ],
      weekdayList: [
        '月', '火', '水', '木', '金', '土', '日'
      ],
      weekday: [
        '日', '月', '火', '水', '木', '金', '土'
      ],
      optionsRemainder: {
        theme: 'snow',
        placeholder: '内容を入力...',
        modules: {
          toolbar: [['bold', 'italic', 'underline', 'strike'], [{ 'color': [] }, { 'background': [] }]]
        }
      },
      isMailSend: false,
      mailContent: null,
      tempEventFileGroup: null,
      groupName: null,
      url: null,
      file: [],
      start: new Date(2000, 1, 1, 9, 0),
      end: new Date(2000, 1, 1, 18, 0),
      preventClick: false,
      kouhoBi: [],
      isdisabled: false,
      startDateAndTime: null,
      endDateAndTime: null,
      calendarUserExists: false,
      step: 0,
      reminder_flg: false,
      reminder_before_flg: false,
      start_date: null,
      isActive: false
    }
  },
  watch: {
    reminder_flg: function(value) {
      this.info.reminder_flg = value
    },
    reminder_before_flg: function(value) {
      this.info.reminder_before_flg = value
    },
    start_date: function(value){
      if (value != null) {
        this.info.start = value
        this.isActive = true
      }
    }
  },
  methods: {
    setDepartment (d) {
      let tempUsers = []
      for (const u of this.users) {
        for (const ud of u.departments) {
          if (ud.pk === d.pk) tempUsers.push(u.pk)
        }
      }
      return tempUsers
    },
    setPositions (p) {
      let tempUsers = []
      for (const u of this.users) {
        for (const up of u.positions) {
          if (up.pk === p.pk) tempUsers.push(u)
        }
      }
      return tempUsers
    },
    clickSaveEvent () {
      let dfunc = function x(x) {
        let t = x
        return t
      }
      let tempInfo = dfunc(this.info)
      for (const d of this.info.attendees_departments) {
        let tempUsers = this.setDepartment(d)
        for (const t of tempUsers) {
          let flg = false
          for (const a of this.info.attendees) {
            if (t === a) {
              flg = true
            }
          }
          if (!flg) tempInfo.attendees.push(t)
        }
      }
      for (const p of this.info.attendees_positions) {
        let tempUsers = this.setPositions(p)
        for (const t of tempUsers) {
          let flg = false
          for (const a of this.info.attendees) {
            if (t === a) {
              flg = true
            }
          }
          if (!flg) tempInfo.attendees.push(t)
        }
      }
      this.$store.dispatch('calendar/createSchedules', tempInfo)
    },
    clickRecommendEvent () {
      this.kouhoBi = []
      let dfunc = function x(x) {
        let t = x
        return t
      }
      let param = dfunc(this.info)
      param.after = 0
      param.mtg_time = 1
      param.count = 3
      param.no_candidate = ''
      param.until = 60
      param.company_hash = this.user.companyID
      let start_hour = 0
      let start_minute = 0
      let end_hour = 23
      let end_minute = 59
      param.work_time_start = parseFloat(start_hour + (start_minute / 100))
      param.work_time_end = parseFloat(end_hour + (end_minute / 100))
      // 開始日を計算
      let now = this.info.start != undefined ? new Date(this.info.start) : new Date();
      now = new Date(now.setSeconds(0))
      let nextDay = this.info.start != undefined ? new Date(now.setDate(new Date(this.info.start).getDate() + param.after)) : new Date(now.setDate(new Date().getDate() + param.after))
      param.after = nextDay.toLocaleString('ja-JP')
      for (var i in param.user_hash) {
        var temp1 = param.user_hash_sub.indexOf(param.user_hash[i])
        if (temp1 >= 0) param.user_hash_sub.splice(temp1, 1)
        var temp2 = param.user_hash_share.indexOf(param.user_hash[i])
        if (temp2 >= 0) param.user_hash_share.splice(temp2, 1)
      }
      for (var i in param.user_hash_sub) {
        var temp = param.user_hash_share.indexOf(param.user_hash_sub[i])
        if (temp >= 0) param.user_hash_share.splice(temp, 1)
      }
      if (this.isErrorCheck(param)) {
        this.$store.dispatch('calendar/getRecommendSchedule', param)
        this.step = 1
      }
    },
    closeEditPage () {
      this.$emit('closeEditPage')
    },
    nextDay () {
      let param = this.info
      this.$store.dispatch('calendar/preserveSuggestedSchedules',
        {
          suggestedSchedules: this.recommendDate,
          targetID: null
        }
      )
      param.after = new Date(moment(this.recommendDate[2].start).add('minutes', 30)).toLocaleString('ja-JP')
      this.$store.dispatch('calendar/getRecommendSchedule', param)
      console.debug('*** End *** nextDay')
    },
    prevDay () {
      console.debug('*** Start *** prevDay')
      let param = this.info
      if (this.preserveSuggestedSchedulesList.length === 1) {
        let now = new Date(this.info.start)
        now = new Date(now.setSeconds(0))
        let nextDay = new Date(now.setDate(new Date(this.info.start).getDate()))
        param.after = nextDay.toLocaleString('ja-JP')
        this.$store.dispatch('calendar/restoreSuggestedSchedules')
      } else if (this.preserveSuggestedSchedulesList.length > 1) {
        const beforeTwoSuggestedSchedule = this.preserveSuggestedSchedulesList[this.preserveSuggestedSchedulesList.length - 2]
        param.after = new Date(moment(beforeTwoSuggestedSchedule[2].start).add('minutes', 30)).toLocaleString('ja-JP')
        this.$store.dispatch('calendar/restoreSuggestedSchedules')
      } else if (this.preserveSuggestedSchedulesList.length === 0) {
        return
      }
      this.$store.dispatch('calendar/getRecommendSchedule', param)
      console.debug('*** End *** prevDay')
    },
    makeEvent (m, btnIndex, sk) {
      this.isdisabled = true
      this.$store.dispatch('calendar/resetSuggestedSchedules')
      var u_hash = []
      let tempUsersHash = this.info.user_hash
      for (const d of this.info.user_hash_departments) {
        let tempUsers = this.setDepartment(d)
        for (const t of tempUsers) {
          let flg = false
          for (const a of this.info.user_hash) {
            if (t === a) {
              flg = true
            }
          }
          if (!flg) tempUsersHash.push(t)
        }
      }
      for (const p of this.info.user_hash_positions) {
        let tempUsers = this.setPositions(p)
        for (const t of tempUsers) {
          let flg = false
          for (const a of this.info.user_hash) {
            if (t === a) {
              flg = true
            }
          }
          if (!flg) tempUsersHash.push(t)
        }
      }
      u_hash = tempUsersHash
      u_hash.push(this.recommendDate[btnIndex].uuid)
      var u_hash_share = this.info.user_hash_share
      const id = createUUID()
      var location = ''
      var start = new Date(
        new Date(
          (new Date(m).getFullYear() + '/' + m).split('~')[0]
        ).toLocaleString('ja-JP')
      )
      var end = null
      if (this.info.mtg_time_hour === undefined) {
        this.info.mtg_time_hour = Math.floor(this.info.mtg_time)
      }
      if (this.info.mtg_time_minute === undefined) {
        this.info.mtg_time_minute = parseInt((this.info.mtg_time - Math.floor(this.info.mtg_time)) * 60)
      }
      end = new Date(
      new Date(moment(start).add('hours', this.info.mtg_time_hour).add('minutes', this.info.mtg_time_minute)).toLocaleString('ja-JP'))
      var isAllDay = false
      var category = 'time'
      var state = ''
      var isVisible = true
      var isPrivate = 'public'
      var isReadOnly = false
      var color = '#000'
      var bgColor = '#59C8C9'
      var borderColor = '#59C8C9'
      var dragBgColor = '#59C8C9'
      var u_h = []
      var isError = false
      if (this.recommendDate[btnIndex].uuid.split(',').length > 1) u_h = this.recommendDate[btnIndex].uuid.split(',')
      else u_h.push(this.recommendDate[btnIndex].uuid)
      var createdSchedule = {
        id: id,
        scheduleId: id,
        user_hash: u_h,
        user_hash_list: u_hash,
        user_hash_share: u_hash_share,
        company_hash: this.info.company_hash,
        title: this.info.title,
        location: location,
        start: start,
        end: end,
        memo: this.info.memo ? this.info.memo : '',
        isAllDay: isAllDay,
        category: category,
        state: state,
        isVisible: isVisible,
        isPrivate: isPrivate,
        isReadOnly: isReadOnly,
        color: color,
        bgColor: bgColor,
        borderColor: borderColor,
        dragBgColor: dragBgColor,
        is_AND: this.info.is_AND,
        re_message: m,
        is_private: isPrivate,
        sessionid: sk.sessionid,
        seekerid: sk.id
      }
      this.$store.dispatch('calendar/autoCreateSchedule', createdSchedule)
        .then((eventData) => {
          if(eventData == null) {
            alert('エラーが発生しました。再度登録しなおしてください。')
            this.isdisabled = false
            return true
          }
          this.$store.dispatch('calendar/sendScheduleEmail', {
            'to': u_hash,
            'title': '【HRモンスター】' + this.info.title + 'の予定を調整いたしました。',
            'method': 0,
            'info': this.info,
            'dateJson': eventData,
            'date_str': m
          })
          this.$store.dispatch('directtalk/createInterviewHistory', {
            seeker: sk.id,
            interview_start: start,
            interview_end: end,
            interview_comment: '',
          }).then((scheduleData) => {
            this.getSubscribedSeekers()
          })
        // リマインドメール用
        if (this.info.reminder_flg) {
          var param = this.info
          param.date = m
          param.reminder_start = start
          var jstz = require('jstimezonedetect')
          param.reminder_tz = jstz.determine().name()
          this.$store.dispatch('chatbot/sendReminderEmail', {id: sk.sessionid, param: param})
        }
        this.isdisabled = false
        this.startDateAndTime = moment(start).format("YYYY/MM/DD(ddd)HH:mm")
        this.endDateAndTime = moment(end).format("YYYY/MM/DD(ddd)HH:mm")
        const confirm = window.confirm('予定をお取り致しました。\n続けて応募者にメールを送付できます。\nメール編集画面へ遷移しますか？')
        if (confirm) {
          this.step = 2
        } else {
          this.closeEditPage()
        }
      })
      .catch((e) => {
        // 通信に失敗したので再度日程を送信してもらう
        this.isdisabled = false
        console.error(e)
        alert('エラーが発生しました。再度登録しなおしてください。')
        return true
      })
    },
    getUserName (user_hash) {
      let retStr = ''
      let filteredUsers = user_hash.filter(function (x, i, self) {
        return self.indexOf(x) === i
      })
      for (const u of this.users) {
        for (const u2 of filteredUsers) {
          if (u.user_hash === u2) {
            retStr += u.username + ' '
          }
        }
      }
      return retStr
    },
    isErrorCheck (param) {
      if (!param.title) {
        alert('タイトルを入力してください')
        return false
      } else {
        if (param.title.length == 0) {
          alert('タイトルを入力してください')
          return false
        }
      }
      // 面談時間チェック
      if (param.mtg_time_hour <= 0 && param.mtg_time_minute <= 0) {
        alert('面談時間は0より大きい値を入力してください: 2')
        return false
      }
      if ( param.mtg_time_hour > 24 ||
          (param.mtg_time_hour === 24 && param.mtg_time_minute > 0)
        ) {
        alert('面談時間は24時間以内にしてください')
        return false
      }
      if (param.mtg_time_minute > 59) {
        alert('面談時間の分の項目につきましては60分より小さい値を入力してください')
        return false
      }
      // ユーザーチェック
      if (param.user_hash.length === 0) {
        alert('調整するメンバーを一人以上選択してください。')
        return false
      }
      // リマインダーチェック
      if (param.reminder_flg) {
        // リマインダー：メールチェック（タイトル）
        if (!param.reminder_title) {
          alert('リマインダーメールのタイトルを入力してください')
          return false
        } else {
          if (param.reminder_title.length == 0) {
            alert('リマインダーメールのタイトルを入力してください')
            return false
          }
        }
        // リマインダー：メールチェック（To）
        if (!param.reminder_to) {
          alert('リマインダーメールの宛先（To）を入力してください')
          return false
        } else {
          if (param.reminder_to.length == 0) {
            alert('リマインダーメールの宛先（To）を入力してください')
            return false
          }
        }
        // リマインダー：メールチェック（Content）
        if (!param.reminder_content) {
          alert('リマインダーメールの内容を入力してください')
          return false
        } else {
          if (param.reminder_content.length == 0) {
            alert('リマインダーメールの内容を入力してください')
            return false
          }
        }
      }
      return true
    },
    changeAttendees (cs) {
      this.info.attendees = _.xor(this.info.attendees, [cs.calendar_user])
    },
    changeAttendeesSelf (data) {
      this.info.attendees = _.xor(this.info.attendees, [this.user.userHash])
    },
    changeAttendeesFromNo (data) {
      this.info.attendees = _.xor(this.info.attendees, [data.user.user_hash])
    },
    changeUserHash (cs) {
      this.info.user_hash = _.xor(this.info.user_hash, [cs.calendar_user])
    },
    changeUserHashSelf (data) {
      this.info.user_hash = _.xor(this.info.user_hash, [this.user.userHash])
    },
    changeUserHashFromNo (data) {
      this.info.user_hash = _.xor(this.info.user_hash, [data.user.user_hash])
    },
    changeUserHashSub (cs) {
      this.info.user_hash_sub = _.xor(this.info.user_hash_sub, [cs.calendar_user])
    },
    changeUserHashSubSelf (data) {
      this.info.user_hash_sub = _.xor(this.info.user_hash_sub, [this.user.userHash])
    },
    changeUserHashSubFromNo (data) {
      this.info.user_hash_sub = _.xor(this.info.user_hash_sub, [data.user.user_hash])
    },
    changeUserHashShare (cs) {
      this.info.user_hash_share = _.xor(this.info.user_hash_share, [cs.calendar_user])
    },
    changeUserHashShareSelf (data) {
      this.info.user_hash_share = _.xor(this.info.user_hash_share, [this.user.userHash])
    },
    changeUserHashShareFromNo (data) {
      this.info.user_hash_share = _.xor(this.info.user_hash_share, [data.user.user_hash])
    },
    goback () {
      this.step=0
      this.info.attendees = []
    },
    getSubscribedSeekers() {
      const getSeekerConditions = {
        is_archive: this.archiveSwitch,
        is_blacklist: this.blacklistSwitch,
        filter_type: this.orSwitch,
        filter: this.filtered,
        page: this.seekersPages,
        perPage: this.perPage,
        manageid: this.currentManage,
        is_duplicate_seeker_flag: this.isDuplicateSeekerFlag,
        is_get_robo_talk: this.isGetRoboTalk
      }
      const authUser = this.users.filter(i=>i.email === this.user.email)
      this.$store.dispatch('directtalk/getSubscribedSeekers', {conditions: getSeekerConditions, authUser: authUser, isAgent: this.user.isAgent})
    },
    async confirmSchedule (sk) {
      this.isdisabled = true
      var start = new Date(new Date(this.info.start).toLocaleString('ja-JP'))
      var end = null
      if (this.info.mtg_time_hour === undefined) {
        this.info.mtg_time_hour = Math.floor(this.info.mtg_time)
      }
      if (this.info.mtg_time_minute === undefined) {
        this.info.mtg_time_minute = parseInt((this.info.mtg_time - Math.floor(this.info.mtg_time)) * 60)
      }
      end = new Date(
      new Date(moment(start).add('hours', this.info.mtg_time_hour).add('minutes', this.info.mtg_time_minute)).toLocaleString('ja-JP'))
      var m = moment(start).format("YYYY/M/D(ddd)H:mm")+" ~ "+ moment(end).format("H:mm")
      this.$store.dispatch('directtalk/createInterviewHistory', {
        seeker: sk.id,
        interview_start: start,
        interview_end: end,
        interview_comment: '',
      }).then((scheduleData) => {
        this.getSubscribedSeekers()
      })
      // リマインドメール用
      if (this.info.reminder_flg) {
        var param = this.info
        param.date = m
        param.reminder_start = start
        var jstz = require('jstimezonedetect')
        param.reminder_tz = jstz.determine().name()
        this.$store.dispatch('chatbot/sendReminderEmail', {id: sk.sessionid, param: param})
      }
      this.isdisabled = false
      this.startDateAndTime = moment(start).format("YYYY/MM/DD(ddd)HH:mm")
      this.endDateAndTime = moment(end).format("YYYY/MM/DD(ddd)HH:mm")
      const confirm = window.confirm('予定をお取り致しました。\n続けて応募者にメールを送付できます。\nメール編集画面へ遷移しますか？')
      if (confirm) {
        this.step = 2
      } else {
        this.closeEditPage()
      }
    },
    calendarUserExistsCheck() {
      for (let us of this.usersStatusAPI) {
        if (us.status === 'ok') {
          this.calendarUserExists = true
        }
      }
    }
  }
}
</script>

<style lang='scss' scoped>
.card-header {
  display: flex;
}
.edit-title-wrapper {
  display: flex;
  justify-content: space-between;
  padding: 20px;
  border-bottom: solid thin #ccc;
}
.edit-title {
  font-size: 22px;
  font-weight: 700;
}
.img-icon {
  display:    block;
  min-width:  200px;
  min-height: 200px;
  width:      200px;
  height:     200px;
  max-width:  200px;
  max-height: 200px;
  object-fit: cover;
  border-radius: 50%;
  border: solid thin #ccc;
}
.img-icon-sq {
  display:    block;
  min-width:  300px;
  min-height: 250px;
  width:      300px;
  height:     250px;
  max-width:  300px;
  max-height: 250px;
  border-radius: 5px;
  object-fit: cover;
  border: solid thin #ccc;
}
.btn-default-color{
  background: #f8f8f8;
}
.on_switch {
  background: #EE2C98;
  color: #ffffff;
}
.message {
  background: white;
}
.tab-box {
  background: white;
  border: solid thin #ccc;
  border-radius: 8px;
  height: 400px;
  padding: 16px;
  margin-top: 16px;
}
.tab-box-form {
  width: 100%; display: flex; padding: 8px;
}
.tab-box-left {
  width: 30%; display: flex; justify-content: flex-start; align-items: center;
}
.tab-box-right {
  width: 70%; font-size: 13px; padding: 10px; justify-content: flex-start; display: flex;
}
.dot-line {
  height: 10px;
  width: 100%;
  background-image: url('../../../assets/lp/dot.png');
  background-repeat: repeat-x;
  background-size: 10px;
  margin-top: 8px;
  margin-bottom: 8px;
}
/* Image Upload UI */
.upload-form {
  position: relative;
}
.upload-style {
  width: 100px;
  border-radius: 10px;
  text-decoration: none;
}
.upload-style > input {
  display: none;
}
.button-img {
  width: 300px;
  text-decoration: none !important;
}
.description {
  font-size: 14px;
}
.select_list {
  margin: 16px 0 16px 32px;
  display: flex;
  align-items: center;
}
.patern_num {
  font-size: 14px;
  font-weight: bold;
  margin-right: 16px;
}
.ConnectingWord {
  font-size: 14px;
  margin: 6px;
}
.input_point {
  width: 64px;
}
.if_select {
  margin: 16px;
}
.close-wrapper {
  cursor: pointer;
  font-weight: bold;
  opacity: 0.6;
  margin-left: 16px;
  &:hover {
    opacity: 1;
    color: red;
  }
  .mdi-close {
    &:before {
      font-weight: bold;
    }
  }
}
.checkbox-item-container {
  font-size: 14px;
  padding:10px;
  padding-left:20px;
  &.-wrapper {
    align-items: center;
  }
}
.checkbox-index {
  margin-right: 8px;
}

/* ポイント入力の際勝手に動くバグがあるため、手動入力に変更 */
input[type='number']::-webkit-outer-spin-button,
input[type='number']::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
input[type='number'] {
  -moz-appearance:textfield;
}
input::-ms-clear {
  visibility:hidden
}

.quote-list {
  height: 240px;
  position: absolute;
  right: 8px;
  top: 64px;
  width: 560px;
  border-radius: 5px;
  text-align: left;
  background-color: #ffffff;
  box-shadow: 0 0 3px grey;
  z-index: 10;
  overflow: auto;
  .list-title {
    font-weight: bold;
    margin-bottom: 8px;
  }
}
table thead th {
  top: 0;
  z-index: 1;
  background: #ffffff;
  border: 1px solid #000000;
}
.close-btn {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/Calendar/organisms/ModalCreateInterviewDate.vue